import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import _ from 'lodash';

import useAxios from '@/network/useAxios';
import { programBoardList } from '@/network/apis/apiUri';
import useContent from '@/localization/data_export';
import '../css/mainBanner.scss';

function FilterItem({ item }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  if (item.url_link === null || item.url_link?.[0].replace(/\s/g, '') === '')
    return <img src={item.image.url} className="mainBannerImage" alt={item.title || `mainBanner_image`} />;
  else
    return (
      <a href={item.url_link[0]} target={'_blank'} rel="noreferrer" title={anchorTitle}>
        <img src={item.image.url} className="mainBannerImage" alt="" />
      </a>
    );
}

export default function MainBanner() {
  const { mode } = useSelector((state) => state);
  const boardCustomType = useContent('boardCustomType');

  const mostData = {
    lan_code: mode,
    title: '',
    content_category: '',
    event_category: null,
    is_open_allow: true,
    is_blind_allow: false,
    hit: true,
    page_info: { row_count: -1, number: 0 },
  };

  const [popupListItem, popupListItemRefetch] = useAxios(programBoardList, [], {}, false);
  const { data: popupList } = popupListItem;

  useEffect(() => {
    if (boardCustomType) {
      setBoardCustomBoardId();
    }
  }, [boardCustomType]);

  const setBoardCustomBoardId = async () => {
    const csv = _.find(boardCustomType.csv, { type: '29' });
    await popupListItemRefetch({
      ...mostData,
      board_id: parseInt(csv.id),
    });
  };

  // 언어 선택에 따라 배너에 보여줄지 결정
  const [popupListForRender, setPopupListForRender] = useState([]);
  const items = popupList?.item;
  useEffect(() => {
    if (popupList) {
      const tmpArr =
        mode === 'en'
          ? items?.filter((v) => {
              return v.content !== '2';
            })
          : items?.filter((v) => {
              return v.content !== '1';
            });
      setPopupListForRender(tmpArr);
    }
  }, [mode, popupList]);

  const [popupClose, setPopupClose] = useState(false);
  const [popupDay, setPopupDay] = useState(false);

  const bannerClose = () => {
    setPopupClose(true);
    if (popupDay) setCookie('mainBanner', 'off', 3);
  };

  const setCookie = (cookie_name, value, days) => {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + days);

    let cookie_value = escape(value) + (days == null ? '' : '; expires=' + exdate.toUTCString());
    document.cookie = cookie_name + '=' + cookie_value;
  };

  const getCookie = (cookie_name) => {
    let x, y;
    let val = document.cookie.split(';');
    for (let i = 0; i < val.length; i++) {
      x = val[i].substr(0, val[i].indexOf('='));
      y = val[i].substr(val[i].indexOf('=') + 1);
      x = x.replace(/^\s+|\s+$/g, '');
      if (x === cookie_name) {
        return unescape(y);
      }
    }
  };

  useEffect(() => {
    getCookie('mainBanner') === 'off' && setPopupClose(true);
  }, []);

  if (popupClose || popupListForRender?.length === 0) return null;
  else
    return (
      <section id="MainBanner">
        {popupListForRender?.length === 1 ? (
          <FilterItem item={popupListForRender[0]} />
        ) : (
          <Swiper slidesPerView={'auto'} spaceBetween={1} autoHeight={true}>
            {popupListForRender?.map((v, i) => (
              <SwiperSlide key={`mainBanner${i}`}>
                <FilterItem item={v} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        <div className="mainBanner-btn">
          <button type="button" onClick={() => setPopupDay(!popupDay)} className="banner_text">
            <p>{mode === 'en' ? 'Not seen for 3 days' : '3일 동안 보지 않기'}</p>
            <img
              src={require(`@/assets/images/icon/ico_search_check_${popupDay ? 'on' : 'off'}.png`).default}
              alt="close button"
            />
          </button>
          <button type="button" className="banner_close" onClick={bannerClose} />
        </div>
      </section>
    );
}
